export default __webpack_public_path__ + "static/h11-19a9284348ebab1780cefe9f5507e6bb.png";